import React from "react";
import { Menu, Image, Icon } from "semantic-ui-react";
import Assets from "mpm-assets";
import { Link } from "react-router-dom";
import Routes from "mpm-config/Routes";
import GlobalContext from "mpm-config/context/MPMContext";
import Utilities from "mpm-config/Utilities";
const MenuOnly = (props) => {
  
  return( Utilities.isAutorizedUser(props.user, props.item.roles) && 
    <Menu.Item
    as={Link}
    to={props.item.path}
    active={props.activeMenu === props.item.key}
    onClick={props.handleItemClick.bind(this, { menu: props.item.key })}
  >
    <div className="menu-container">
      <div className="menu-icon">
        {props.item.icon ? <Image src={props.item.icon} /> : null}
      </div>
      <Menu.Header as="span" className="menu-label">
        {props.item.name}
      </Menu.Header>
    </div>
  </Menu.Item>
  )
};
const MenuWithChildren = (props) => {
  
  return(Utilities.isAutorizedUser(props.user, props.item.roles) && 
    <Menu.Item
    as="div"
    to={props.item.path}
    active={props.activeMenu === props.item.key}
    onClick={props.handleItemClick.bind(this, { menu: props.item.key })}
  >
    <div className="menu-container">
      <div className="menu-icon">
        {props.item.icon ? <Image src={props.item.icon} /> : null}
      </div>
      <Menu.Header as="span" className="menu-label">
        {props.item.name}
      </Menu.Header>
    </div>
    <Menu.Menu className="menu-children">
      {props.item.children.map((itemChildren, j) => (Utilities.isAutorizedUser(props.user, itemChildren.roles) && 
        <Menu.Item
          as={Link}
          key={j}
          to={itemChildren.path}
          active={
            props.activeMenu === props.item.key &&
            props.activeItem === itemChildren.key
          }
          onClick={props.handleItemClick.bind(this, {
            menu: props.item.key,
            item: itemChildren.key,
          })}
        >
          <div className="menu-container">
            <div className="menu-icon">
              <Icon name="dot circle outline" color="yellow" />
            </div>
            <Menu.Header as="span" className="menu-label">
              {itemChildren.name}
            </Menu.Header>
          </div>
        </Menu.Item>
      ))}
    </Menu.Menu>
  </Menu.Item>
  )
};
class SideMenuMobile extends React.Component {
  state = {
    activeItem: Utilities.getCurrentMenuItemActive(),
    activeMenu: Utilities.getCurrentMenuActive(),
    connectedUser : this.context.connectedUser
  };

  handleItemClick = (e) =>{
    this.setState({ activeMenu: e.menu, activeItem: Utilities.getCurrentMenuItemActive() });
    if(e.item){
      this.props.hideSidebar();
    }
  }

  render() {
    const { activeItem, activeMenu, connectedUser } = this.state;

    return (
      <div id="side-menu" className={`side-menu big bg-blue-800`}>
        <div className="side-menu-content">
          <div className="logo-mpm-container">
            <Image
              src={Assets.Images.logo_mpm_big}
              as="a"
              size="medium"
              href="/"
            />
          </div> 
          <Menu icon pointing secondary vertical className="menu-list">
            {Routes.map((item, i) => !item.hidden && (
              item.children !== undefined ? (
                <MenuWithChildren
                  item={item}
                  key={i}
                  activeItem={activeItem}
                  activeMenu={activeMenu}
                  handleItemClick={(e) => this.handleItemClick(e)}
                  user={connectedUser}
                />
              ) : (
                <MenuOnly
                  item={item}
                  key={i}
                  activeItem={activeItem}
                  activeMenu={activeMenu}
                  
                  handleItemClick={(e) => {this.handleItemClick(e); this.props.hideSidebar()}}
                  user={connectedUser}
                />
              )
            ))}
          </Menu> 
        </div>
      </div>
    );
  }
}
SideMenuMobile.contextType = GlobalContext;
export default SideMenuMobile;
